module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "normala"
  }, [_vm._v("If you think you can reason with evil, then go ahead and I wish you great success. But talking is not my bag. My specialty is warfare and my goal is destruction. I am going to bust this kingdom of evil if I can live that long. I AM GOING TO DESTROY THE MAFIA.")]), _vm._v(" "), _c('p', {
    staticClass: "right1-2"
  }, [_c('span', [_vm._v("—Mack Bolan, "), _c('i', [_vm._v("The Executioner")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-366da96d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/franmatter01.vue
// module id = 75
// module chunks = 0